import React from 'react'
import Offers from '@commons/offers'

const OfferProvided = ({ user }) => {
  return <Offers user={user} />
}

export default OfferProvided
